import React, { useState } from 'react';

// Renders a platform's iOS-style app icon. On error, falls back to a colored
// gradient tile with the platform's letter so the layout never breaks.
export default function PlatformLogo({ platform, size = 56, rounded = 'rounded-xl' }) {
  const [failed, setFailed] = useState(false);
  const s = { width: size, height: size };

  if (failed || !platform.logo) {
    return (
      <div style={s} className={`${rounded} bg-gradient-to-br ${platform.color} flex items-center justify-center font-display text-white shadow-lg shrink-0`}>
        <span style={{ fontSize: size * 0.5, lineHeight: 1 }}>{platform.letter}</span>
      </div>
    );
  }

  return (
    <div style={s} className={`${rounded} overflow-hidden shadow-lg shrink-0 bg-neutral-100`}>
      <img
        src={platform.logo}
        alt={platform.name}
        onError={() => setFailed(true)}
        className="w-full h-full object-cover"
      />
    </div>
  );
}
